(function ($) {
    const loadMore = $("#more_btn");
    const filterBtn = $("#filter-btn");
    const filterClosedBtn = $("#filter-closed");
    const filter = $("#filter");

    filterBtn.on('click', function (e) {
        e.preventDefault();
        filter.toggleClass('active');  // Переключаем класс для показа/скрытия
    });

// Закрытие фильтра по клику на кнопку "Закрыть"
    filterClosedBtn.on('click', function (e) {
        e.preventDefault();  // Предотвращаем стандартное поведение, если нужно
        if (filter.hasClass('active')) {
            filter.removeClass('active');  // Убираем класс, чтобы скрыть фильтр
        }
    });

    $(document).on('mouseup', function (e) {
        if (
            !filter.is(e.target) &&
            filter.has(e.target).length === 0 &&
            !filterBtn.is(e.target) &&
            !filterClosedBtn.is(e.target)
        ) {
            filter.removeClass('active');  // Убираем класс, чтобы скрыть фильтр
        }
    });


    $('#filter input, #filter select, #filter button, #filter textarea').prop('disabled', true);

    $(window).on('load', function () {
        $('#filter input, #filter select, #filter button, #filter textarea').prop('disabled', false);
    });

    handleSearch();

    function handleSelectAll(containerID)
    {
        let container = $("#" + containerID);
        let allCheckbox = container.find(".select-all-checkbox");
        let childCheckboxes = container
        .find('input[type="checkbox"]')
        .not(".select-all-checkbox");

        allCheckbox.change(function () {
            let isChecked = $(this).prop("checked");
            childCheckboxes.prop("checked", isChecked);
        });

        childCheckboxes.change(function () {
            let allChecked =
            childCheckboxes.filter(":checked").length === childCheckboxes.length;
            allCheckbox.prop("checked", allChecked);
        });
    }

    handleSelectAll("services_checkbox_container");
    handleSelectAll("area_checkbox_container");
    handleSelectAll("metro_checkbox_container");
    handleSelectAll("hair_color_checkbox_container");
    handleSelectAll("bust_checkbox_container");

    function updateMoreBtn(response)
    {
        if ($.trim(response).length === 0) {
            loadMore.hide();
        } else {
            loadMore.show();
        }
    }

    function sendRequest(page)
    {
        let modelVerified = $("#model_verified_checkbox").prop("checked")
        ? "checked"
        : "";
        let modelHasVideo = $("#model_has_video").prop("checked") ? "checked" : "";

        $.ajax({
            url: filter.attr("action"),
            type: filter.attr("method"),
            data:
            filter.serialize() +
            "&paged=" +
            page +
            "&checkbox=" +
            modelVerified +
            "&model_has_video=" +
            modelHasVideo,
            beforeSend: function () {
                loadMore.text("Загрузка...");
            },
            success: function (response) {
                $("#response").append(response);
                loadMore.text("Показать еще").data("page", page + 1);
                updateMoreBtn(response);

                lazyLoad();
                initializeSliders();
            },
            error: function () {
                loadMore.text("Показать еще");
            },
        });
    }

    $(document).on("click", "#more_btn", function () {
        let page = $(this).data("page");
        sendRequest(page);
    });

    $('input[type="checkbox"]').change(function () {
        let checkbox = $(this);
        let parentElement = checkbox.closest(".checkbox");

        if (checkbox.is(":checked")) {
            parentElement.addClass("active");
        } else {
            parentElement.removeClass("active");
        }
    });

    let $checkboxHandler = `
    #services_checkbox_container input[type="checkbox"],
    #area_checkbox_container input[type="checkbox"],
    #metro_checkbox_container input[type="checkbox"],
    #model_verified_checkbox, #model_has_video,
    #bust_checkbox_container input[type="checkbox"],
    #hair_color_checkbox_container input[type="checkbox"],
    #price_range_container input[type="number"],
    #params_checkbox_container input[type="number"]
    `;

    $(document).ready(function () {
        initializeSliders();

        $(document).on("change", $checkboxHandler, function () {
            let formData = filter.serializeArray();

            let servicesArray = [];
            let areaArray = [];
            let metroArray = [];
            let bustSize = [];
            let hairColor = [];
            let priceHour = [];
            let priceTwoHour = [];
            let priceNight = [];
            let modelHeight = [];
            let modelWeight = [];
            let modelAge = [];

            $('#services_checkbox_container input[type="checkbox"]:checked').each(
                function () {
                    servicesArray.push($(this).val());
                }
            );

            $('#area_checkbox_container input[type="checkbox"]:checked').each(
                function () {
                    areaArray.push($(this).val());
                }
            );

            $('#metro_checkbox_container input[type="checkbox"]:checked').each(
                function () {
                    metroArray.push($(this).val());
                }
            );

            $('#bust_checkbox_container input[type="checkbox"]:checked').each(
                function () {
                    bustSize.push($(this).val());
                }
            );

            $('#hair_color_checkbox_container input[type="checkbox"]:checked').each(
                function () {
                    hairColor.push($(this).val());
                }
            );

            $.ajax({
                url: filter.attr("action"),
                data: formData,
                type: filter.attr("method"),
                dataType: "html",
                beforeSend: function () {
                    $("#loader").css("display", "block").show();
                    $(".loader-body").css("display", "flex").show();
                },
                success: function (response) {
                    $("#response").html(response);

                    loadMore.data("page", 2);
                    updateMoreBtn(response);

                    lazyLoad();
                    initializeSliders();
                },
                complete: function () {
                    $("#loader").css("display", "none").hide();
                    $(".loader-body").css("display", "none").hide();

                    const divCount = $('#response a').length;
                    
                    if (divCount <= 2) {
                        $('#response').addClass('below-two');
                    }

                    if (divCount > 2) {
                        $('#response').removeClass('below-two');
                    }
                },
            });
        });
    });

    updateMoreBtn($("#response").html());
})(jQuery);